import { dayOfWeek } from '@/const/shared'

export function orderWeekDays() {
  return [
    { key: 'MONDAY', value: dayOfWeek.MONDAY },
    { key: 'TUESDAY', value: dayOfWeek.TUESDAY },
    { key: 'WEDNESDAY', value: dayOfWeek.WEDNESDAY },
    { key: 'THURSDAY', value: dayOfWeek.THURSDAY },
    { key: 'FRIDAY', value: dayOfWeek.FRIDAY },
    { key: 'SATURDAY', value: dayOfWeek.SATURDAY },
    { key: 'SUNDAY', value: dayOfWeek.SUNDAY }
  ]
}
